export const ALLOW_COOKIES = 'ALLOW_COOKIES';
